import { Button } from '@/components/ui/button';
import { Moon, Sun, Monitor } from 'lucide-react';
import type { Theme } from '@/hooks/use-dark-mode';

type SimpleThemeToggleProps = {
    theme: Theme;
    onCycle: () => void;
} | {
    isDark: boolean;
    onToggle: () => void;
};

const themeIcons = {
    light: Sun,
    dark: Moon,
    system: Monitor,
} as const;

export function SimpleThemeToggle(props: SimpleThemeToggleProps) {
    // Legacy API support
    if ('isDark' in props) {
        const Icon = props.isDark ? Moon : Sun;
        return (
            <Button
                variant="outline"
                size="icon"
                className="text-foreground"
                onClick={props.onToggle}
                aria-label={`Switch to ${props.isDark ? 'light' : 'dark'} theme`}
            >
                <Icon className="h-4 w-4" />
            </Button>
        );
    }

    const { theme, onCycle } = props;
    const Icon = themeIcons[theme];
    const nextTheme = theme === 'system' ? 'light' : theme === 'light' ? 'dark' : 'system';

    return (
        <Button
            variant="outline"
            size="icon"
            className="text-foreground"
            onClick={onCycle}
            aria-label={`Current: ${theme}. Switch to ${nextTheme}`}
        >
            <Icon className="h-4 w-4" />
        </Button>
    );
}